export default __webpack_public_path__ + "static/media/lot-img-1.2cb4255c.jpg";